/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — it's completely free, runs in your browser, and needs no signup or download.`)
};

const es_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — es completamente gratis, funciona en tu navegador y no necesita registro ni descarga.`)
};

const de_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — er ist völlig kostenlos, läuft direkt in deinem Browser und benötigt weder Anmeldung noch Download.`)
};

const nl_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — hij is volledig gratis, draait in je browser en vereist geen aanmelding of download.`)
};

const fr_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — il est entièrement gratuit, fonctionne dans votre navigateur et ne nécessite ni inscription ni téléchargement.`)
};

const it_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — è completamente gratuito, funziona nel tuo browser e non richiede registrazione né download.`)
};

const pt_br2_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — é totalmente grátis, roda no seu navegador e não precisa de cadastro nem download.`)
};

const pt_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — é completamente gratuito, funciona no seu navegador e não precisa de registo nem de transferências.`)
};

const ja_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、完全無料です。ブラウザ上で動作し、登録やダウンロードも必要ありません。`)
};

const zh_typing_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的 — 完全免费，在浏览器中运行，无需注册或下载。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq3_a", locale)
	if (locale === "en") return en_typing_hub_faq3_a(inputs)
	if (locale === "es") return es_typing_hub_faq3_a(inputs)
	if (locale === "de") return de_typing_hub_faq3_a(inputs)
	if (locale === "nl") return nl_typing_hub_faq3_a(inputs)
	if (locale === "fr") return fr_typing_hub_faq3_a(inputs)
	if (locale === "it") return it_typing_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq3_a(inputs)
	if (locale === "pt") return pt_typing_hub_faq3_a(inputs)
	if (locale === "ja") return ja_typing_hub_faq3_a(inputs)
	return zh_typing_hub_faq3_a(inputs)
};